import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Form,
  Nav,
  Tab,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../components/Card";
import moment from "moment";
import loader from "../../assets/images/page-img/page-load-loader.gif";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from "react-i18next";

import "./styles.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getToken } from "../../utils/auth";
import { useNavigate, useParams } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import useAuth from "../../utils/useAuth";
import Sponsored from "./Sponsored";
import { MdOutlineDone } from "react-icons/md";
import { useLogoLink } from "../../Context/LogoLinkContext";

const EventTemplate = () => {
    const logoLink = useLogoLink();
  
  useAuth();
  const navigate = useNavigate();
    const { t, i18n } = useTranslation();
  
const {id} = useParams();
  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
    startDate: "",
    endDate: "",
    location: "",
    note: "",
    category: "public",
  });

  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "file") {
      const file = e.target.files[0];
      setFormData({
        ...formData,
        [name]: file,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };
  const handleEvent = async () => {
    if (
      !formData.title ||
      !description ||
      !formData.location ||
      !formData.image ||
      !formData.startDate ||
      !formData.endDate ||
      !categorypost
    ) {
      toast.error("All fields are required");
      return;
    }

    try {
      const formDataObject = new FormData();
      formDataObject.append("title", formData.title);
      formDataObject.append("description", description);
      formDataObject.append("image", formData.image);
      formDataObject.append("startDate", formData.startDate);
      formDataObject.append("endDate", formData.endDate);
      formDataObject.append("location", formData.location);
      formDataObject.append("note", formData.note);
      formDataObject.append("category", categorypost);
      formDataObject.append("eventType", "global");

      const token = getToken();

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/event`,
        formDataObject, // Changed variable name here
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Event created successfully");
      handleAllPost(true);
      setFormData({
        title: "",
        description: "",
        image: "",
        startDate: "",
        endDate: "",
        location: "",
        note: "",
        category: "public",
      });
      setDescription("");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed creating Event");
      console.log("Failed creating Event", error);
    } finally {
      setShow(false);
    }
  };

  const [post, setPost] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState("");
  const [eventType, setEventType] = useState("");
  const handleAllPost = async () => {
    try {
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/event/${id}`;
     
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setData(response.data.data.event);
    } catch (error) {
      console.log("Failed Fetching Event", error);
    }
  };

  useEffect(() => {
    if(id){
    handleAllPost();
  }
  }, [id]);

  useEffect(() => {
    handleAllPost(true);
  }, [eventType]);


  const renderDescription = (data, index) => {
    const description = data?.description;
    const threshold = 180;

    if (description && description.length > threshold) {
      if (expandedRows[index]) {
        return (
          <div>
            <div dangerouslySetInnerHTML={{ __html: description }} />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "rgb(47,178,255)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "block",
              }}
            >
              Show Less
            </button>
          </div>
        );
      } else {
        return (
          <div>
            <div
              style={{ display: "inline" }}
              dangerouslySetInnerHTML={{
                __html: `${description.slice(0, threshold)}...`,
              }}
            />
            <button
              onClick={() => toggleExpand(index)}
              style={{
                color: "rgb(47,178,255)",
                background: "none",
                border: "none",
                cursor: "pointer",
                display: "inline",
              }}
            >
              Show More
            </button>
          </div>
        );
      }
    } else {
      return <div dangerouslySetInnerHTML={{ __html: description }} />;
    }
  };
  const [currentDate, setCurrentDate] = useState("");

  useEffect(() => {
    const intervalId = setInterval(() => {
      const date = new Date();
      const dayOfMonth = date.getDate();
      setCurrentDate(dayOfMonth);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const [expandedPosts, setExpandedPosts] = useState(
    Array(post.length).fill(false)
  );

  const toggleExpanded = (index) => {
    const updatedExpandedPosts = [...expandedPosts];
    updatedExpandedPosts[index] = !updatedExpandedPosts[index];
    setExpandedPosts(updatedExpandedPosts);
  };
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    const day = now.getDate().toString().padStart(2, "0");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportDescription, setReportDescription] = useState("");
  const [reportId, setReportId] = useState("");
  const handleReportClick = (reqid) => {
    setReportId(reqid);
    setReportModalOpen(true);
  };

  const closeReportModal = () => {
    setReportModalOpen(false);
  };
  const handleReport = async () => {
    if (!reportDescription) {
      toast.info("Report issue is required");
      return;
    }
    try {
      const token = getToken();
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/report`,
        {
          reportFor: "event",
          issueDescription: reportDescription,
          userId: "",
          postId: "",
          eventId: reportId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      closeReportModal();
      setReportId("");
      setReportDescription("");
      toast.success(response.data.message);
    } catch (error) {
      setReportId("");
      setReportDescription("");
      toast.error(error?.response?.data?.message || "Failed Reporting Post");
      console.log("Failed SaviReportingng Posts", error);
    }
  };

  const [qrPopupOpen, setQrPopupOpen] = useState(false);
  const [qrImageUrl, setQrImageUrl] = useState("");

  const handleQrClick = (imageUrl) => {
    setQrImageUrl(imageUrl);
    setQrPopupOpen(true);
  };

  const closeQrPopup = () => {
    setQrPopupOpen(false);
  };

  const handleGoingStatus = async (eventid, status) => {
    try {
      const token = getToken();
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/api/event/going-status/${eventid}`,
        {
          goingStatus: status,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      handleAllPost(true);
      toast.success(response.data.message);
    } catch (error) {
      console.error("Failed Chnaging Status");
      toast.error(error?.response?.data?.message || "Failed Updating Status");
    }
  };
  const endDateRef = useRef(null);

  const navigateprofile = (id) => {
    navigate(`/userprofile/${id}`);
  };
  const handleLogin = () => {
    navigate(`/auth/sign-in`);
  };

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>

      <div className="iq-top-navbar">
        <Row className="">
          <Col className="d-flex justify-content-between align-items-center">
            <Link
              to="/"
              className="d-flex align-items-center gap-2 iq-header-logo" style={{}}
            >
              {/* <img src="/Logo.png" alt="logo" style={{ height: "60px" }} /> */}
              <img src={logoLink || "/diridologo.jpg"} alt="logo" style={{ height: "50px", padding:"5px 10px" }} />

            </Link>
            {/* <button
              type="submit"
              className="btn btn-primary d-block w-100 mt-0"
              style={{ maxWidth: "100px", marginRight: "15px" }}
              onClick={handleLogin}
            >
              Login
            </button> */}
          </Col>
        </Row>
      </div>
      <div id="content-page" className="content-page">
        <Container>
          <Row>
            <Col lg={8} className="row  p-0" style={{ margin: "auto" }}>
            <Col sm={12} >
                    <Card className=" card-block card-stretch card-height">
                      <Card.Body>
                        <div className="user-post-data">
                          <div className="d-flex justify-content-between">
                            <div className="me-3">
                              <img
                                className="rounded-circle img-fluid"
                                src="/calender.webp"
                                style={{ width: "55px" }}
                                alt=""
                              />
                              <div
                                style={{
                                  justifyContent: "center",
                                  fontSize: "20px",
                                  fontWeight: "600",
                                  marginTop: "-75%",
                                  display: "flex",
                                  color: "rgb(58,51,61)",
                                }}
                              >
                                {moment(
                                  data?.startDate ? data?.startDate : "1"
                                ).format("D")}
                              </div>
                            </div>
                            <div className="w-100">
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h5 className="mb-0 d-inline-block">
                                    {data?.title}
                                  </h5>
                                  <p
                                    className="mb-0 text-primary"
                                    style={{ color: "black" }}
                                  >
                                    {data?.location}
                                  </p>
                                </div>
                                <div
                                  className="card-post-toolbar"
                                  style={{ display: "flex" }}
                                >
                                  {data?.qrCodeUrl ? (
                                    <div>
                                      <img
                                        src={data?.qrCodeUrl}
                                        onClick={() =>
                                          handleQrClick(data?.qrCodeUrl)
                                        }
                                        style={{
                                          width: "50px",
                                          height: "50px",
                                        }}
                                      />
                                    </div>
                                  ) : (
                                    <div></div>
                                  )}
                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-evenly",
                            marginTop: "20px",
                          }}
                        >
                          <div className="containergrid">
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                Start Date
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.startDate).format(
                                  "MMM D, YYYY"
                                )}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                Start Time
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.startDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                End Date
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.endDate).format("MMM D, YYYY")}
                              </div>
                            </div>
                            <div className="boxgrid">
                              <div
                                style={{ fontSize: "12px", color: "#a5a5a5" }}
                              >
                                End Time
                              </div>
                              <div style={{ fontSize: "14px" }}>
                                {moment(data?.endDate)
                                  .utc(0)
                                  .format("h:mm A")}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            background: "#ececec",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px",
                            borderRadius: "10px",
                            marginTop: "20px",
                          }}
                        >
                          <div style={{ flex: "1", marginRight: "10px" }}>
                            <strong
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigateprofile(data?.userId?._id)
                              }
                            >
                              {data?.userId?.firstName
                                ? data?.userId?.firstName
                                : "John"}
                            </strong>{" "}
                            created event
                          </div>
                          <div>
                            <button
                              style={{
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "going")
                              }
                            >
                              Going - {data?.goingStatusCount?.goingCount}
                            </button>
                            <button
                              style={{
                                marginRight: "10px",
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "maybe")
                              }
                            >
                              Maybe - {data?.goingStatusCount?.maybeCount}
                            </button>
                            <button
                              style={{
                                border: "none",
                                borderRadius: "10px",
                                background: "#d3d3d3",
                                padding: "2px 5px",
                                color: "black",
                              }}
                              onClick={(e) =>
                                handleGoingStatus(data?._id, "not-going")
                              }
                            >
                              Can't Go -{" "}
                              {data?.goingStatusCount?.notGoingCount}
                            </button>
                          </div>
                        </div>
                        <div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "right",
                              color: "red",
                            }}
                          >
                            {data?.note ? (
                              <div>Note: {data?.note}</div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                            <>
                              <div className="mt-3">
                                <p>{renderDescription(data)}</p>
                              </div>
                              {data?.image && (
                              <div className="user-post">
                                <img
                                  src={data?.image}
                                  alt="post1"
                                  className="img-fluid rounded w-100"
                                />
                              </div>)}
                            </>
                        
                        </div>

                      </Card.Body>
                    </Card>
                  </Col>
            </Col>
          </Row>
        </Container>
      </div>
         <Modal
                        size="sm"
                        className="fade"
                        id="qr-modal"
                        onHide={closeQrPopup}
                        show={qrPopupOpen}
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>{t('qr_code')}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center">
                          <img
                            src={qrImageUrl}
                            alt="QR Code"
                            style={{ maxWidth: "100%", height: "auto" }}
                          />
                        </Modal.Body>
                        <Modal.Footer>
                          <button
                            className="btn btn-secondary"
                            onClick={closeQrPopup}
                          >
                            {t('close')}
                          </button>
                        </Modal.Footer>
                      </Modal>
    </>
  );
};

export default EventTemplate;
